import Wizard from './lib/Wizard';

export default Wizard;
